import { Autocomplete, TextField } from '@mui/material';
import { SyntheticEvent } from 'react';
import { useTranslation } from 'react-i18next';

import { useEmploymentData } from '~/features/ScheduledEmploymentChanges/ScheduleChanges/components/Employment/useEmploymentData';
import { PendingScheduleChanges } from '~/features/ScheduledEmploymentChanges/ScheduleChanges/useScheduleChanges';
import { useSchedulePendingEmployment } from '~/features/ScheduledEmploymentChanges/ScheduleChanges/useSchedulePendingEmployment';

import { ScheduledEmploymentMenuOption } from '../../component';

interface Props {
  selectedEmployeeId: number;
  handleChangeEmployment: (employment: PendingScheduleChanges | null) => void;
}

export const PendingEmploymentsMenu = ({
  selectedEmployeeId,
  handleChangeEmployment,
}: Props) => {
  const { t } = useTranslation();
  const { data: employmentData } = useEmploymentData({
    employeeId: selectedEmployeeId,
  });

  const { data: pendingEmploymentDetails } =
    useSchedulePendingEmployment(selectedEmployeeId);

  const handleChange = (
    e: SyntheticEvent,
    value: ScheduledEmploymentMenuOption | null,
  ) => {
    const selectedEmployment = pendingEmploymentDetails.find((emplt) => {
      return emplt?.employmentDetails?.fEmplId === value?.id;
    });
    handleChangeEmployment(selectedEmployment || null);
  };

  const firstOption: ScheduledEmploymentMenuOption = {
    startDate: employmentData[0]?.fEmplDateStart,
    endDate: employmentData[0]?.fEmplTerminationDate || 'Continuous',
    id: employmentData[0]?.fEmplId,
  };

  const pendingEmploymentOptions = pendingEmploymentDetails
    .filter(
      (employment) =>
        !!Object.keys(employment || {}).length &&
        !!Object.keys(employment?.employment || {}).length,
    )
    .map((employment) => {
      return {
        startDate: employment?.employment?.fEmplDateStart || '',
        endDate: employment?.employment?.fEmplTerminationDate || 'Continuous',
        id: employment?.employment?.fEmplId || '',
      } as ScheduledEmploymentMenuOption;
    });

  const options = [firstOption, ...pendingEmploymentOptions];

  return (
    <>
      <Autocomplete
        options={options}
        sx={{ margin: '0 10px' }}
        getOptionLabel={({ startDate, endDate }) => `${startDate} - ${endDate}`}
        isOptionEqualToValue={(a, b) => a.id === b.id}
        onChange={handleChange}
        renderInput={(params) => (
          <TextField
            required
            {...params}
            fullWidth
            label={t('selectEmployment')}
            sx={{ width: '200px' }}
            size="small"
          />
        )}
      />
    </>
  );
};
